import { AxiosResponse } from 'axios'
import axiosInstance from '../../config/axios'
import { ILoggedUser, IRefreshTokenResponse } from '../../store/auth/userTypes'
import authUrls from '../../utils/urls/authUrls'
import reportsUrls from '../../utils/urls/reportsUrls'

export const loginUser = (email: string, password: string): Promise<AxiosResponse<ILoggedUser>> =>
  axiosInstance.post<ILoggedUser>(authUrls.login(), {
    email,
    password,
  })

export const forgotPassword = (email: string): Promise<AxiosResponse<ILoggedUser>> =>
  axiosInstance.post<ILoggedUser>(authUrls.forgotPassword(), {
    email,
  })

export const resetPassword = (
  password: string,
  token: string,
): Promise<AxiosResponse<ILoggedUser>> =>
  axiosInstance.post<ILoggedUser>(authUrls.resetPassword(), {
    password,
    token,
  })

export const refreshToken = (refresh: string): Promise<AxiosResponse<IRefreshTokenResponse>> =>
  axiosInstance.post(authUrls.refreshToken(), { refresh })

export const getUserDetails = (userId: string): Promise<AxiosResponse> =>
  axiosInstance.get(authUrls.getUserDetails(userId))

export const getUserReportAccess = (report: number, user: number): Promise<AxiosResponse> =>
  axiosInstance.get(`${reportsUrls?.getReportAssignsUrl()}/access`, {
    params: {
      user,
      report,
    },
  })

export default {
  loginUser,
  resetPassword,
  forgotPassword,
  refreshToken,
  getUserDetails,
  getUserReportAccess,
}
